import { publishIsBusy } from './PublishStore';

export const updatePublishIsBusy = (value) => publishIsBusy.update((oldValue) => value);
